// extracted by mini-css-extract-plugin
module.exports = {"blockSelector":"BlockSelector_blockSelector__1X5i3"};